<template>
  <svg
    viewBox="0 0 100 100"
    preserveAspectRatio="none"
    xmlns="http://www.w3.org/2000/svg">
    <line x1="49" x2="49" y1="5" y2="70" stroke-width="4px" />
    <line x1="49" x2="100" y1="30" y2="30" />
    <line x1="49" x2="100" y1="70" y2="70" />
    <rect x="40" y="5" width="20" height="5" />
    <rect x="85" y="27" width="20" height="5" />
    <rect x="85" y="67" width="20" height="5" />
  </svg>
</template>

<script>
export default {
  name: 'InfoGridDecorativeLines'
}
</script>

<style scoped>
svg {
  overflow: visible;
  width: 100%;
  height: 100%;
  stroke: #99CC33;
  stroke-width: 2px;
  fill: #99CC33;
}
</style>


// WEBPACK FOOTER //
// src/components/buyer-listing-details-as-pdf/partials/InfoGridDecorativeLines.vue